(function() {
  // Shopify money formatter (uses the shop's format)
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '€{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  function updateAtcPrice() {
    var variantInput = document.querySelector('.product-variant-id');
    if (!variantInput) return;
    var variantId = variantInput.value;
    if (!variantId) return;

    // Find variant data from product JSON
    var productJsonScript = document.querySelector('[id^="ProductJson-"], [id^="ProductJSON-"]');
    var productData = null;

    // Fallback: use Shopify's product object embedded in page
    if (!productData) {
      var script = document.querySelector('script[type="application/json"][data-product-json]');
      if (script) {
        try { productData = JSON.parse(script.textContent); } catch(e) {}
      }
    }

    // Easiest: fetch the variant price from Shopify directly
    fetch(window.location.pathname + '.js')
      .then(r => r.json())
      .then(data => {
        var variant = data.variants.find(v => v.id == variantId);
        if (!variant) return;
        var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '€{{amount_with_comma_separator}}';
        var formatted = formatMoney(variant.price, moneyFormat);
        document.querySelectorAll('.js-atc-price').forEach(el => el.innerHTML = formatted);
      });
  }

  // Listen for variant changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="id"], select[name="id"], .product-variant-id, [name^="option"]')) {
      setTimeout(updateAtcPrice, 100);
    }
  });

  // Also listen for custom variant change events the theme might fire
  document.addEventListener('variant:change', updateAtcPrice);
  document.addEventListener('variantChange', updateAtcPrice);
})();